import Capture from "../assests/Capture.PNG"
import port from "../assests/porfolio.PNG"
import ecco from "../assests/ecoomerce.PNG"
import shop from "../assests/shop.PNG"
import image from "../assests/imageClassifier.jpeg"
import mern from "../assests/mern.PNG"
import gp from "../assests/gamerpal.png"
import globe from "../assests/globe.png"

export const Data=[
  
    {
        "id": 1,
        "projectTitle":"Social Media Application",
        "techStack":"MernStack",
        "link":"https://63476f2abbe59735b9e03c43--taskap45698.netlify.app/",
        "imageSrc":mern

    },
    {
        "id": 2,
        "projectTitle":" GamerPal",
        "techStack":"MEAN Stack",
        "link":"https://drive.google.com/file/d/15K3w6Yr40_7yVT_jem2Tt7YkB4Ndfahm/view?usp=sharing/",
        "imageSrc":gp

    },
    {
        "id": 3,
        "projectTitle":"Chat Application",
        "techStack":"Built using HTML,CSS,JS and Database as Firebase",
        "link":"https://hellochatbytarun.netlify.app/",
        "imageSrc":Capture

    },
    {
        "id": 4,
        "projectTitle":"Online Nursery",
        "techStack":"Built using react js and Firebase as database",
        "link":"https://greenify-13813.web.app/",
        "imageSrc":ecco

    },
    {
        "id": 5,
        "projectTitle":" Shop here",
        "techStack":"Built using reactjs,Tailwind css,MUI,Firebase as database and Rapid api",
        "link":"https://react-ecommerce-be808.web.app/",
        "imageSrc":shop

    },
    {
        "id": 6,
        "projectTitle":" Image Clasifier",
        "techStack":"Built using reactjs,TensorFlow js COCOSSD model",
        "link":"https://fake-book-321d1.web.app/",
        "imageSrc":image
        
    },
    {
        "id": 7,
        "projectTitle":" Weather application",
        "techStack":"Built using reactjs,Threejs, netlify,Reactive",
        "link":"https://64f15e1cf4e4b01d1d238c57--weather00225.netlify.app/",
        "imageSrc":globe
    },
]